import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useAuthStore, homeFor } from "../store/auth";
import { logout as apiLogout } from "../lib/api";

export function TopBar({ subtitle }: { subtitle?: string }) {
  const { t, i18n } = useTranslation(["common", "admin"]);
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);

  function switchLang() {
    const next = i18n.language === "ja" ? "en" : "ja";
    void i18n.changeLanguage(next);
    try {
      localStorage.setItem("locale", next);
    } catch {
      // 保存できなくても切り替えは効く
    }
  }

  async function onLogout() {
    await apiLogout();
    navigate("/login", { replace: true });
  }

  const roleLabel =
    user?.role === "system_admin" ? t("common:role_system_admin")
    : user?.role === "org-admin" ? t("common:role_org_admin")
    : user?.role === "teacher" ? t("common:role_teacher")
    : "";

  return (
    <header className="bg-white border-b border-gray-200">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <Link to={homeFor(user?.role)} className="flex items-center gap-3 min-w-0">
          <div className="w-8 h-8 shrink-0 rounded-full bg-sakura flex items-center justify-center text-primary font-bold text-sm">N</div>
          <div className="min-w-0">
            <div className="text-sm font-bold text-primary">{t("common:app_name")}</div>
            {subtitle && <div className="text-xs text-muted truncate">{subtitle}</div>}
          </div>
        </Link>
        <div className="flex items-center gap-3">
          {user && (
            <span className="text-sm text-muted hidden sm:inline">
              {user.name}
              {roleLabel && <span className="ml-2 text-xs border border-gray-200 rounded px-1.5 py-0.5">{roleLabel}</span>}
            </span>
          )}
          <button onClick={switchLang} className="text-xs text-primary border border-gray-200 rounded px-2 py-1">
            {i18n.language === "ja" ? "EN" : "JP"}
          </button>
          <button onClick={onLogout} className="text-xs text-muted border border-gray-200 rounded px-2 py-1">
            {t("common:logout")}
          </button>
        </div>
      </div>
    </header>
  );
}
